// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"83da3958","595":"0b41c306"}[chunkId] + ".chunk.js";
};